"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AgencySearchList = _interopRequireDefault(require("../../../components/finpro/AgencySearchList"));
var _AgentSearchList = _interopRequireDefault(require("../../../components/finpro/AgentSearchList"));
var _MultiplePinMap = require("../../../components/finpro/maps/MultiplePinMap");
var _ResultNotFound = _interopRequireDefault(require("../../../components/finpro/ResultNotFound"));
var _richTextField = require("../../../lib/richTextField");
var _ChecklistDropdown = _interopRequireDefault(require("./ChecklistDropdown.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _PaginationControls = _interopRequireDefault(require("../PaginationControls"));
var _DistanceFilterDropdown = _interopRequireDefault(require("./DistanceFilterDropdown.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Results(_ref) {
  var _apiData$data;
  var {
    currentPage,
    apiData,
    finProOrAgencySelection,
    lastSearchedTerm,
    setHoverId,
    agencyKey,
    formData,
    isMmfa
  } = _ref;
  if (!(apiData !== null && apiData !== void 0 && (_apiData$data = apiData.data) !== null && _apiData$data !== void 0 && (_apiData$data = _apiData$data.data) !== null && _apiData$data !== void 0 && _apiData$data.hits)) {
    return /*#__PURE__*/_react.default.createElement(_ResultNotFound.default, {
      noResultMessage: "<span>No results found for <strong>".concat(lastSearchedTerm ? lastSearchedTerm : '""', "</strong></span>"),
      isMmfa: isMmfa
    });
  } else if (finProOrAgencySelection === 'Financial Professional') {
    var _apiData$data2;
    return /*#__PURE__*/_react.default.createElement(_AgentSearchList.default, {
      currentPage: currentPage,
      agents: apiData === null || apiData === void 0 || (_apiData$data2 = apiData.data) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2.data) === null || _apiData$data2 === void 0 ? void 0 : _apiData$data2.hits,
      setHoverId: setHoverId,
      agencyKey: agencyKey,
      formData: formData
    });
  } else {
    var _apiData$data3;
    return /*#__PURE__*/_react.default.createElement(_AgencySearchList.default, {
      currentPage: currentPage,
      agencies: apiData === null || apiData === void 0 || (_apiData$data3 = apiData.data) === null || _apiData$data3 === void 0 || (_apiData$data3 = _apiData$data3.data) === null || _apiData$data3 === void 0 ? void 0 : _apiData$data3.hits,
      setHoverId: setHoverId,
      agencyKey: agencyKey,
      isMmfa: isMmfa
    });
  }
}
function Filters(_ref2) {
  var _apiData$data4, _apiData$data5, _apiData$data6, _apiData$data7, _apiData$data8, _apiData$data9;
  var {
    searchState,
    setSearchState,
    apiData,
    onSearch,
    showResetFilters,
    setShowMapPopup
  } = _ref2;
  var finproLabel = (apiData === null || apiData === void 0 || (_apiData$data4 = apiData.data) === null || _apiData$data4 === void 0 || (_apiData$data4 = _apiData$data4.data) === null || _apiData$data4 === void 0 ? void 0 : _apiData$data4.totalitems) === 1 ? 'Financial Professional' : 'Financial Professionals';
  var agencyLabel = (apiData === null || apiData === void 0 || (_apiData$data5 = apiData.data) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.data) === null || _apiData$data5 === void 0 ? void 0 : _apiData$data5.totalitems) === 1 ? 'Agency' : 'Agencies';
  var resultsDescription = searchState.finProOrAgencySelection === 'Financial Professional' ? " ".concat(finproLabel, " ").concat(searchState.lastSearchedWasByName ? 'named' : 'near', " \"").concat(searchState.lastSearchedTerm, "\"") : " ".concat(agencyLabel, " ").concat(searchState.lastSearchedWasByName ? 'named' : 'near', " \"").concat(searchState.lastSearchedTerm, "\"");
  var hideDistanceFilter = !!(searchState.lastSearchedWasByName || searchState.hideDistanceFilter);
  var hideChecklistFilters = searchState.finProOrAgencySelection !== 'Financial Professional';
  var hideResetButton = hideChecklistFilters || !showResetFilters;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "full-width-tablet-mobile"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, " ".concat(apiData !== null && apiData !== void 0 && (_apiData$data6 = apiData.data) !== null && _apiData$data6 !== void 0 && (_apiData$data6 = _apiData$data6.data) !== null && _apiData$data6 !== void 0 && _apiData$data6.totalitems ? apiData === null || apiData === void 0 || (_apiData$data7 = apiData.data) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7.data) === null || _apiData$data7 === void 0 ? void 0 : _apiData$data7.totalitems : '0', " ")), resultsDescription)), /*#__PURE__*/_react.default.createElement("div", {
    className: "filters"
  }, hideDistanceFilter ? null : /*#__PURE__*/_react.default.createElement(_DistanceFilterDropdown.default, {
    searchState: searchState,
    setSearchState: setSearchState,
    apiData: apiData,
    onSearch: onSearch
  }), hideChecklistFilters ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, apiData !== null && apiData !== void 0 && (_apiData$data8 = apiData.data) !== null && _apiData$data8 !== void 0 && (_apiData$data8 = _apiData$data8.data) !== null && _apiData$data8 !== void 0 && _apiData$data8.languagefacet ? /*#__PURE__*/_react.default.createElement(_ChecklistDropdown.default, {
    searchState: searchState,
    setSearchState: setSearchState,
    applyOnClick: onSearch,
    apiData: apiData,
    defaultLabel: "Languages",
    type: "language"
  }) : null, apiData !== null && apiData !== void 0 && (_apiData$data9 = apiData.data) !== null && _apiData$data9 !== void 0 && (_apiData$data9 = _apiData$data9.data) !== null && _apiData$data9 !== void 0 && _apiData$data9.specialtyfacet ? /*#__PURE__*/_react.default.createElement(_ChecklistDropdown.default, {
    searchState: searchState,
    setSearchState: setSearchState,
    applyOnClick: onSearch,
    apiData: apiData,
    defaultLabel: "Specialties",
    type: "specialty"
  }) : null), hideResetButton ? null : /*#__PURE__*/_react.default.createElement(ResetFiltersButton, {
    setSearchState: setSearchState,
    onSearch: onSearch,
    apiData: apiData
  })), /*#__PURE__*/_react.default.createElement(ViewMapButton, {
    setShowMapPopup: setShowMapPopup
  }));
}
function ResetFiltersButton(_ref3) {
  var _apiData$data0;
  var {
    setSearchState,
    onSearch,
    apiData
  } = _ref3;
  if ((apiData === null || apiData === void 0 || (_apiData$data0 = apiData.data) === null || _apiData$data0 === void 0 || (_apiData$data0 = _apiData$data0.data) === null || _apiData$data0 === void 0 ? void 0 : _apiData$data0.totalitems) === 0) return null;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-link reset-filter-button",
    onClick: () => {
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          languageSelection: [],
          specialtySelection: []
        });
      });
      onSearch();
    }
  }, "Reset Filters");
}
function Loading() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-filter-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-dots-loading-xl",
    role: "img",
    "aria-label": "MassMutual Logo"
  }));
}
function ViewMapButton(_ref4) {
  var {
    setShowMapPopup
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mm-tablet-mobile-only view-map-button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "btn view-map-button",
    onClick: () => setShowMapPopup(true)
  }, "View the Map"));
}
function FilterAndResults(_ref5) {
  var {
    searchState,
    setSearchState,
    apiData,
    isLoading,
    onSearch,
    mapData,
    hoverId,
    setHoverId,
    disclaimer,
    formData,
    googleApiIsLoaded,
    initialApiDataIsSet,
    showResetFilters,
    setShowMapPopup,
    redoSearchOnClick,
    isMmfa
  } = _ref5;
  var [currentPage, setCurrentPage] = (0, _react.useState)(1);
  var [totalPages, setTotalPages] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    var _apiData$data1;
    if (apiData !== null && apiData !== void 0 && (_apiData$data1 = apiData.data) !== null && _apiData$data1 !== void 0 && (_apiData$data1 = _apiData$data1.data) !== null && _apiData$data1 !== void 0 && _apiData$data1.hits) {
      var _apiData$data10;
      setTotalPages(Math.ceil((apiData === null || apiData === void 0 || (_apiData$data10 = apiData.data) === null || _apiData$data10 === void 0 || (_apiData$data10 = _apiData$data10.data) === null || _apiData$data10 === void 0 ? void 0 : _apiData$data10.totalitems) / 10));
      setCurrentPage(1);
    } else {
      setTotalPages(0);
      setCurrentPage(1);
    }
  }, [apiData]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "search-filter-container"
  }, isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "filters-loading"
  }) : /*#__PURE__*/_react.default.createElement(Filters, {
    searchState: searchState,
    setSearchState: setSearchState,
    apiData: apiData,
    onSearch: onSearch,
    showResetFilters: showResetFilters,
    setShowMapPopup: setShowMapPopup
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "finpro-search-results-row ".concat(isLoading ? 'loading' : '')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 8,
    md: 12,
    sm: 12,
    className: "results-col"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(Loading, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Results, {
    currentPage: currentPage,
    apiData: apiData,
    finProOrAgencySelection: searchState.finProOrAgencySelection,
    lastSearchedTerm: searchState.lastSearchedTerm,
    setHoverId: setHoverId,
    agencyKey: mapData.agencyKey,
    formData: formData,
    isMmfa: isMmfa
  }), /*#__PURE__*/_react.default.createElement(_PaginationControls.default, {
    totalPages: totalPages,
    currentPage: currentPage,
    setCurrentPage: setCurrentPage
  }), !isMmfa && /*#__PURE__*/_react.default.createElement("div", {
    className: "disclaimer"
  }, (0, _richTextField.parseHTML)(disclaimer)))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    className: "mm-desktop-only map-col"
  }, googleApiIsLoaded && initialApiDataIsSet ? /*#__PURE__*/_react.default.createElement(_MultiplePinMap.MultiplePinMap, {
    agencyList: mapData.agencyData,
    hoverId: hoverId,
    setHoverId: setHoverId,
    redoSearchOnClick: redoSearchOnClick
  }) : null)));
}
var _default = exports.default = FilterAndResults;